export class ServiceCategoryEntity {
    serviceCategoryId: string
    name: string
    color?: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    status: number
}
